import React,{Component} from 'react';
import {Modal,Button,Row,Col,Form} from 'react-bootstrap';
import axios from 'axios';
import Multiselect from 'multiselect-react-dropdown';


export  class EditTopicTechMapping extends Component{
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            TopicList:[],
            TechnologyIds:""
            
        }
      

    }
    componentDidMount() {
      
      
    }  
    
 
    
      onSelect(selectedList, selectedItem) {
        this.state.TechnologyIds ="";
        for(let i=0;i<selectedList.length;i++)
        {
        this.state.TechnologyIds += ","+selectedList[i].technologyid;
        }
      }
      
      onRemove(selectedList, removedItem) {
      
        this.state.TechnologyIds ="";
        for(let i=0;i<selectedList.length;i++)
        {
          this.state.TechnologyIds += ","+selectedList[i].technologyid;
        }
      }
  
    handleSubmit(event){
        event.preventDefault();
        const options = {
            headers: {"content-type": "text/plain"}
        }
    const article = {topicid:event.target.topicid.value,TechnologyId: this.state.TechnologyIds,username:this.props.username};
    axios.post('https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopicTech/Post', article,options)
        .then((result)=> {            
           
             },
             (error) => {
              
           }) 
           alert("Data saved successfully");
           this.props.onHide();
    }

    render(){
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg' aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Edit Topic
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form onSubmit={this.handleSubmit}>

                          <Form.Group controlId='topics'>
                              <div class="col-md-6">
                              <Form.Label>TopicsId</Form.Label>
                              <Form.Control type='text' style={{width:275}} name='topicid' required
                              disabled defaultValue={this.props.TopicId} ></Form.Control>
                              </div>
                           
                              
                          </Form.Group> 
                          <Form.Group controlId='topics'>
                             
                             
                              <div class="col-md-6">
                              <Form.Label>Task Name</Form.Label>
                              <Form.Control as="textarea" rows="2" style={{width:275}} name='TaskName' required
                              disabled defaultValue={this.props.TaskName} ></Form.Control>
                            
                              </div>
                              <div class="col-md-6">
                              <Form.Label>KT Phase</Form.Label>
                              <Form.Control type='text' style={{width:275}} name='Phase' required
                              disabled defaultValue={this.props.Phase} ></Form.Control>
                             
                              </div>
                              <div class="col-md-6">
                              <Form.Label>Topic</Form.Label>
                              <Form.Control as="textarea" rows="2" disabled style={{width:275}} defaultValue={this.props.Topic} name='topic' required ></Form.Control>
                             
                              </div>
                              <div class="col-md-12">
                              <label for=" " class="control-label margin-bottom5  margin-top5" >Technology*</label>
       
                                <Multiselect
                                
                                options={this.props.TechListAll} 
                                selectedValues={this.props.TechList} 
                                onSelect={this.onSelect.bind(this)} 
                                onRemove={this.onRemove.bind(this)}
                                avoidHighlightFirstOption={true}
                                displayValue="technology" 
                                ref={this.multiselectRef2}
                                />
                              </div>
                             
                              
                              
                          </Form.Group>  
                          <Form.Group>
                              <Button variant='primary' style={{margin:10}} className='btn-new btn-confirm' type='submit'>
                                  Save
                              </Button> 
                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm'>Close
                              </Button>
                          </Form.Group>  
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
               
            </Modal>
            </div>
        )
    }
}